import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import DigitalLectureVideoCard from './DigitalLectureVideoCard'
import { ResearchShowcaseCard } from '~/models/research-showcase'

export default class DigitalLectureSpeakerDetail extends BaseModel {
  static override constructorName = 'DigitalLectureSpeakerDetail'

  id: number = 0
  name: string = ''
  'middle_name': string = ''
  'last_name': string = ''
  'full_name': string = ''
  position: string = ''
  photo: string = ''
  description: string = ''
  videos: DigitalLectureVideoCard[] = []
  'research_showcases': ResearchShowcaseCard[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['videos', 'research_showcases'])

      this.photo = toCroppedImage(this.photo)

      this.videos = convertToArrayModels(data.videos, DigitalLectureVideoCard)
      this.research_showcases = convertToArrayModels(data.research_showcases, ResearchShowcaseCard)
    }
  }
}

registerModel(DigitalLectureSpeakerDetail)
